import { CheckCircleIcon } from "@heroicons/react/24/solid"
import PropTypes from 'prop-types'

const ImageRadioGroup = ({ 
  classNames = {}, 
  handleChange, 
  options, 
  selectedOptionIds = [], 
  isDisabled = false 
}) => {
  const getOptionIdsArray = (optionId) => {
    return selectedOptionIds.includes(optionId)
      ? selectedOptionIds.filter((id) => id !== optionId)
      : [...selectedOptionIds, optionId]
  }

  const containerClasses = classNames?.container || ""
  const itemClasses = classNames?.items || ""

  return (
    <div className={`flex gap-3 ${containerClasses}`}>
      {Object.keys(options).map(key => {
        const option = options[key]
        const isSelected = selectedOptionIds.includes(option.id)
        return (
          <div
            key={option.id}
            className={`${itemClasses} grow ${isDisabled ? 'pointer-events-none' : 'hover:cursor-pointer'} border-8 flex items-center justify-center flex-col relative rounded-lg p-6 transition-all duration-300 ${isSelected ? 'border-green-200 bg-green-500' : 'border-gray-200 bg-gray-500 dark:bg-content2 border-4'}`}
            onClick={() => handleChange(getOptionIdsArray(option.id))}
          >
            {isSelected && <CheckCircleIcon className="absolute h-16 text-green-200 -top-6 -right-5" />}

            <div className="text-white opacity-70">{option.image}</div>

            <h1 className='mt-3 text-xl font-semibold text-center text-white'>
              {option.label}
            </h1>

            <p className="text-sm text-center text-white">{option.description}</p>
          </div>
        )
      })}
    </div>
  )
}

ImageRadioGroup.propTypes = {
  classNames: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  options: PropTypes.object.isRequired,
  selectedOptionIds: PropTypes.array,
}

export default ImageRadioGroup
